import React from 'react';
import { MuiStack } from './stackComponent';
import SkeletonLoader from './sketeton';
var JobItemsLoader = function () {
    return /*#__PURE__*/ React.createElement(MuiStack, {
        direction: 'column'
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        direction: 'column',
        spacing: 1,
        style: {
            width: '100vw',
            height: '9vh',
            padding: '16px 16px 8px 16px'
        }
    }, /*#__PURE__*/ React.createElement(SkeletonLoader, null)), /*#__PURE__*/ React.createElement(MuiStack, {
        alignItems: 'center',
        style: {
            width: '100vw',
            height: '49px',
            padding: 2,
            borderBottom: '1px solid rgba(0, 0, 0, 0.12)'
        }
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        style: {
            width: '150px',
            height: '20px',
            padding: 2,
            paddingLeft: 10
        }
    }, /*#__PURE__*/ React.createElement(SkeletonLoader, null))), /*#__PURE__*/ React.createElement(MuiStack, {
        alignItems: 'center',
        style: {
            width: '100vw',
            height: '49px',
            padding: 2,
            borderBottom: '1px solid rgba(0, 0, 0, 0.12)'
        }
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        style: {
            width: '200px',
            height: '20px',
            padding: 2,
            paddingLeft: 10
        }
    }, /*#__PURE__*/ React.createElement(SkeletonLoader, null))), /*#__PURE__*/ React.createElement(MuiStack, {
        alignItems: 'center',
        style: {
            width: '100vw',
            height: '49px',
            padding: 2,
            borderBottom: '1px solid rgba(0, 0, 0, 0.12)'
        }
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        style: {
            width: '130px',
            height: '20px',
            padding: 2,
            paddingLeft: 10
        }
    }, /*#__PURE__*/ React.createElement(SkeletonLoader, null))), /*#__PURE__*/ React.createElement(MuiStack, {
        alignItems: 'center',
        style: {
            width: '100vw',
            height: '49px',
            padding: 2,
            borderBottom: '1px solid rgba(0, 0, 0, 0.12)'
        }
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        style: {
            width: '170px',
            height: '20px',
            padding: 2,
            paddingLeft: 10
        }
    }, /*#__PURE__*/ React.createElement(SkeletonLoader, null))), /*#__PURE__*/ React.createElement(MuiStack, {
        alignItems: 'center',
        style: {
            width: '100vw',
            height: '49px',
            padding: 2,
            borderBottom: '1px solid rgba(0, 0, 0, 0.12)'
        }
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        style: {
            width: '240px',
            height: '20px',
            padding: 2,
            paddingLeft: 10
        }
    }, /*#__PURE__*/ React.createElement(SkeletonLoader, null))), /*#__PURE__*/ React.createElement(MuiStack, {
        alignItems: 'center',
        style: {
            width: '100vw',
            height: '49px',
            padding: 2,
            borderBottom: '1px solid rgba(0, 0, 0, 0.12)'
        }
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        style: {
            width: '300px',
            height: '20px',
            padding: 2,
            paddingLeft: 10
        }
    }, /*#__PURE__*/ React.createElement(SkeletonLoader, null))), /*#__PURE__*/ React.createElement(MuiStack, {
        alignItems: 'center',
        style: {
            width: '100vw',
            height: '49px',
            padding: 2,
            borderBottom: '1px solid rgba(0, 0, 0, 0.12)'
        }
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        style: {
            width: '100px',
            height: '20px',
            padding: 2,
            paddingLeft: 10
        }
    }, /*#__PURE__*/ React.createElement(SkeletonLoader, null))), /*#__PURE__*/ React.createElement(MuiStack, {
        alignItems: 'center',
        style: {
            width: '100vw',
            height: '49px',
            padding: 2,
            borderBottom: '1px solid rgba(0, 0, 0, 0.12)'
        }
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        style: {
            width: '220px',
            height: '20px',
            padding: 2,
            paddingLeft: 10
        }
    }, /*#__PURE__*/ React.createElement(SkeletonLoader, null))));
};
export default JobItemsLoader;
